module.exports = "./912ec66d7572ff821749319396470bde.svg";